<template>
    <div class="edit-page max-content" v-if="passedLogin">
        <van-sticky>
            <top title="简介更新" :color="color"></top>
        </van-sticky>
        <van-loading v-if="!loaded" class="page-loading" type="spinner" color="#901D22" />
        <template v-else>
            <div class="edit-body">
                <div class="photo-wrap">
                    <div class="photo-box">
                        <img :src="photoSrc" alt="" @error="onImgError">
                        <button type="button" class="camera" @click="pickPhoto">
                            <van-icon name="photo-o" color="#fff" size="22" />
                        </button>
                        <input ref="file" class="file-input" type="file" accept="image/*" @change="onPhoto">
                    </div>
                </div>
                <div class="form">
                    <div class="row">
                        <span class="label">姓名</span>
                        <input v-model.trim="form.name" class="value" type="text" maxlength="20" placeholder="填写姓名">
                    </div>
                    <div class="row">
                        <span class="label">医院</span>
                        <input v-model.trim="form.hospital" class="value" type="text" maxlength="50" placeholder="填写医院">
                    </div>
                    <div class="intro-block">
                        <p class="label">简介</p>
                        <textarea v-model="form.intro" maxlength="2000" placeholder="请输入简介"></textarea>
                    </div>
                </div>
            </div>
            <div class="bottom-btn">
                <button type="button" class="save-btn" :class="{ disabled: !canSave }" @click="onSave">保存</button>
            </div>
        </template>
    </div>
</template>
<script>
import Top from "../components/Top";
import { uploadImg, NewMeetingDetail } from "../../../config/interface.js";
import { ensureLogin, fetchExpertResume, submitExpertResume, isResumeClosed, markResumeClosedTip } from "./resumeMock";

export default {
    components: {
        Top
    },
    data() {
        return {
            passedLogin: false,
            loaded: false,
            form: {
                id: "",
                name: "",
                hospital: "",
                intro: "",
                photo: ""
            },
            photoPreview: "",
            saving: false,
            uploadingPhoto: false,
            resumeEndTime: "",
            defaultPhoto: require("@/assets/images/default_user.png"),
            color: "#901D22",
        };
    },
    computed: {
        meetingId() {
            return this.$route.query.meeting_id || this.$route.query.id || this.$route.query.MT_id || "";
        },
        photoSrc() {
            return this.photoPreview || this.form.photo || this.defaultPhoto;
        },
        canSave() {
            return !this.uploadingPhoto && !!(this.form.name && this.form.name.trim() && this.form.hospital && this.form.hospital.trim() && this.form.intro && this.form.intro.trim());
        }
    },
    created() {
        this.init();

    },
    mounted() {
        this.getMeetingDetailsNew(this.meetingId);
        let keyTimer = null;
        document.body.addEventListener('focusin', () => {
            //软键盘弹起事件
            clearInterval(keyTimer);
        });
        document.body.addEventListener('focusout', () => {
            // 软键盘关闭事件
            window.scrollTo(0, 0);
            keyTimer = setTimeout(() => {
                if (window.pageYOffset > 0) {
                    window.scrollTo(0, 0);
                }
            }, 200);
        })
    },
    methods: {
        getMeetingDetailsNew(id) {
            fetch(NewMeetingDetail(id), {}, "GET").then((res) => {
                if (res.code == 0) {
                    let data = res.data;
                    document.title = data.name;
                    if (res.data.theme_color_hex) {
                        this.color = res.data.theme_color_hex;
                    } else {
                        this.color = "#901D22";
                    }
                }
            });
        },
        init() {
            ensureLogin(this).then((user) => {
                if (!user) {
                    return;
                }
                fetchExpertResume(this.meetingId).then((data) => {
                    if (!data.ok) {
                        this.$toast(data.message || "获取简历失败");
                        this.$router.replace({
                            path: "/vascularNews/expert/myResume",
                            query: {
                                meeting_id: this.meetingId
                            }
                        });
                        return;
                    }
                    if (!data.bound) {
                        this.$router.replace({
                            path: "/vascularNews/expert/myResume",
                            query: {
                                meeting_id: this.meetingId
                            }
                        });
                        return;
                    }
                    if (isResumeClosed(data.resume_end_time)) {
                        markResumeClosedTip();
                        this.$router.replace({
                            path: "/vascularNews/expert/myResume",
                            query: {
                                meeting_id: this.meetingId
                            }
                        });
                        return;
                    }
                    this.passedLogin = true;
                    this.resumeEndTime = data.resume_end_time || "";
                    this.form = {
                        id: data.id || "",
                        name: data.name || "",
                        hospital: data.hospital || "",
                        intro: data.intro || "",
                        photo: data.photo || "",
                        meeting_id: this.meetingId
                    };
                    this.loaded = true;
                });
            });
        },
        onImgError(event) {
            event.target.src = this.defaultPhoto;
        },
        pickPhoto() {
            this.$refs.file && this.$refs.file.click();
        },
        onPhoto(event) {
            const file = event.target.files && event.target.files[0];
            event.target.value = "";
            if (!file) {
                return;
            }
            if (!/^image\//.test(file.type)) {
                this.$toast("请选择图片");
                return;
            }
            this.photoPreview = URL.createObjectURL(file);
            this.uploadingPhoto = true;
            const formData = new FormData();
            formData.append("file", file);
            fetch(uploadImg, formData, "POST").then((res) => {
                this.uploadingPhoto = false;
                if (res && res.code == 0 && res.data) {
                    this.form.photo = res.data.url
                    return;
                }
                this.photoPreview = "";
                this.$toast("图片上传失败");
            }).catch(() => {
                this.uploadingPhoto = false;
                this.photoPreview = "";
                this.$toast("图片上传失败");
            });
        },
        onSave() {
            if (isResumeClosed(this.resumeEndTime)) {
                markResumeClosedTip();
                this.$router.replace({
                    path: "/vascularNews/expert/myResume",
                    query: {
                        meeting_id: this.meetingId
                    }
                });
                return;
            }
            if (!this.canSave || this.saving || this.uploadingPhoto) {
                if (this.uploadingPhoto) {
                    this.$toast("图片上传中");
                }
                return;
            }
            this.saving = true;
            submitExpertResume(this.meetingId, this.form).then(() => {
                this.$router.replace({
                    path: "/vascularNews/expert/myResume",
                    query: {
                        meeting_id: this.meetingId
                    }
                });
            }).catch((err) => {
                this.saving = false;
                if (!err || !err.error_msg) {
                    this.$toast("保存失败，请稍后重试");
                }
            });
        }
    }
};
</script>
<style scoped lang="scss">
.edit-page {
    height: 100vh;
    background: #fff;
    display: flex;
    flex-direction: column;

    /deep/ .van-nav-bar__right span {
        display: none;
    }
}

.page-loading {
    margin: 80px auto;
}

.edit-body {
    flex: 1;
    // padding-bottom: 10px;
    overflow: auto;
}

.photo-wrap {
    background: #fff;
    padding: 28px 0 24px;
}

.photo-box {
    position: relative;
    width: 148px;
    margin: 0 auto;

    img {
        width: 148px;
        height: 148px;
        object-fit: cover;
        display: block;
        background: #f2f2f2;
    }

    .camera {
        position: absolute;
        right: -8px;
        bottom: -8px;
        width: 46px;
        height: 46px;
        border: none;
        border-radius: 50%;
        background: #901D22;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 2px 8px rgba(144, 29, 34, 0.28);
    }

    .file-input {
        display: none;
    }
}

.form {
    margin-top: 10px;
    background: #fff;
    border-top: 10px solid #f7f7f7;
}

.row {
    min-height: 52px;
    display: flex;
    align-items: center;
    padding: 12px 16px;
    border-bottom: 1px solid #f0f0f0;
    background: #fff;

    .label {
        flex-shrink: 0;
        font-size: 15px;
        color: #333;
    }

    .value {
        flex: 1;
        min-width: 0;
        margin-left: 16px;
        border: none;
        outline: none;
        background: transparent;
        text-align: right;
        font-size: 15px;
        color: #333;
        line-height: 22px;
    }

    .value::placeholder {
        color: #c8c8c8;
    }
}

.intro-block {
    background: #fff;
    padding: 14px 16px 0px;

    .label {
        font-size: 15px;
        color: #333;
        line-height: 22px;
    }

    textarea {
        display: block;
        width: 100%;
        min-height: 200px;
        margin-top: 10px;
        padding: 0;
        border: none;
        resize: none;
        outline: none;
        background: transparent;
        font-size: 15px;
        color: #666;
        line-height: 26px;
        box-sizing: border-box;
    }

    textarea::placeholder {
        color: #c8c8c8;
    }
}

.bottom-btn {
    // position: fixed;
    // left: 50%;
    // bottom: 0;
    // transform: translateX(-50%);
    width: 100%;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 20px 24px 30px;
}

.save-btn {
    width: 100%;
    margin: 0 auto;
    height: 46px;
    border: none;
    border-radius: 24px;
    background: #901D22;
    color: #fff;
    font-size: 16px;
    line-height: 16px;

    &.disabled {
        background: #f2f2f2;
        color: #cfcfcf;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/VascularSystem/Expert/Edit.vue